import { action, makeObservable, override } from 'mobx';
import { EntityStore } from '../../../shared/stores/EntityStore';
import { api } from '../../../shared/api/api';

class ExternalApplicationStore extends EntityStore {
	constructor() {
		super('external-applications');
		makeObservable(this);
		this.resetQuery();
	}

	defaultTableColumnsOptions = [
		{ label: 'Applicant Name', value: 'name' },
		{ label: 'Job ID', value: 'jobId' },
		{ label: 'Applicant Role', value: 'applicantRole' },
		{ label: 'Job Position Title', value: 'jobTitle' },
		{ label: 'Client', value: 'clientName' },
		{ label: 'Applied on', value: 'appliedAt' },
		{ label: 'Country', value: 'country' },
		{ label: 'Source', value: 'source' },
		{ label: 'Status', value: 'status' }
	];

	tableColumnsOptions = [...this.defaultTableColumnsOptions];

	@override
	resetQuery() {
		this.query = {
			sort: { column: 'appliedAt', asc: true },
			pagination: this.defaultPagination
		};
	}

	@action
	async approve(id, payload) {
		return api.post(`${this.entityPluralEndpoint}/${id}/approve`, payload);
	}

	@action
	async reject(id, payload) {
		return api.post(`${this.entityPluralEndpoint}/${id}/reject`, payload);
	}

	@action
	async downloadResume(id) {
		return api.get(`${this.entityPluralEndpoint}/${id}/resume`, {
			responseType: 'blob'
		});
	}
}

export const externalApplicationStore = new ExternalApplicationStore();
